import React, { useState } from 'react'
import { CreateUser } from '../../../actions/Users/UserAction';
import { useNavigate } from 'react-router-dom';
import { countryPhoneCodes } from '../../../nametitle/apiFormat';

const ModalAddUser = () => {
  const navigate = useNavigate();
  const [username, setusername] = useState("");
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [email, setemail] = useState("");
  const [telephone, settelephone] = useState("");
  const [code, setcode] = useState("");
  const [password, setpassword] = useState("");
  const [isPassword, setisPassword] = useState(false)

  return (
    <div className=" modal fade " id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-2" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content rounded-0">
          <div className="modal-header relative">
            <h6 className=" modal-title  text-primary text-uppercase display-7 text-uppercase mb-0 translatable" id="exampleModalLabel" style={{ maxWidth: "600px" }}>
              Ajouter nouvel utlisateur
            </h6>
            <button type="button" className="absolute top-3 right-4 btn btn-close text-2xl " data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div className="modal-body container flex justify-center">
            <div className="flex justify-center row g-8">
              <div className="col-lg-9">
                <form onSubmit={(e) => {
                  e.preventDefault();
                  CreateUser(username, firstname, lastname, email, code, telephone, password)
                }}>
                  <div className="row g-3">
                    <div className="col-12">
                      <input type="text" value={username} onChange={(e) => { setusername(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="nom d'utlisateur" style={{ height: "55px" }} />
                    </div>
                    <div className="col-12">
                      <input type="text" value={firstname} onChange={(e) => { setfirstname(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="nom .." style={{ height: "55px" }} />
                    </div>
                    <div className="col-12">
                      <input type="text" value={lastname} onChange={(e) => { setlastname(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="prenoms .." style={{ height: "55px" }} />
                    </div>
                    <div className="col-12">
                      <input type="email" value={email} onChange={(e) => { setemail(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="email" style={{ height: "55px" }} />
                    </div>
                    <div className="col-12 flex">
                      <select className="form-control" onChange={(e)=>setcode(e.target.value)} >
                      {
                        countryPhoneCodes.map((code)=>{
                            return(
                                <option value={code.code} selected={code == code.code? true: false}>{code.code}</option>
                            )
                        })
                    }    
                    
                      </select>
                      <input type="number" value={telephone} onChange={(e) => { settelephone(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="telephone" style={{ height: "55px" }} />
                    </div>
                    <div className="col-12">
                      <input type={isPassword ? "text" : "password"} value={password} onChange={(e) => { setpassword(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="mot de passe" style={{ height: "55px" }} />
                    </div>
                    <div className="col-12 flex space-x-3">
                      <input type="checkbox" checked={isPassword} onChange={(e) => { setisPassword(e.target.checked) }} className="bg-light border-0 px-4" placeholder="mot de passe" style={{ height: "20px" }} />
                      <label className="translatable">Montrer mot de passe</label>
                    </div>
                    <div className="col-12">
                      <button className="btn btn-outline-primary w-100 py-3 translatable" type="submit">Ajouter</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalAddUser;
